export const AeoStandaloneTypeDecorator = {
  url() {
    return `signup-hubspot/aeo`;
  },
  query() {
    return {};
  }
};